import * as Yup from 'yup';

import { ServiceFormPrimaryFields } from './types';

export const initialServiceFormPrimaryValues: ServiceFormPrimaryFields = {
  name: '',
  phone: '',
  message: '',
};

export const validationServiceFormPrimarySchema: Yup.SchemaOf<ServiceFormPrimaryFields> =
  Yup.object().shape({
    name: Yup.string().required('Укажите имя'),
    phone: Yup.string().required('Укажите номер телефона'),
    message: Yup.string(),
  });
